import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-nextPage",
  "use": "icon-nextPage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-nextPage\"><defs><style type=\"text/css\"></style></defs><path d=\"M491.52 51.2a65.1776 65.1776 0 0 0 0 92.16l368.64 368.64-368.64 368.64a65.1776 65.1776 0 0 0-4.4544 87.1936L491.52 972.8a65.1776 65.1776 0 0 0 92.16 0l414.72-414.72a65.1776 65.1776 0 0 0 0-92.16L583.68 51.2a65.1776 65.1776 0 0 0-92.16 0z\" p-id=\"1504\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol